import type { IconSvgObject } from './types';

const Blockchain03Icon: IconSvgObject = [
  ["path", { d: "M6 8.67619V15L12 18.5L18 15.5V8.67619L12 5.5L6 8.67619ZM18 8.67619L12 11.5M12 11.5L6 8.67619M12 11.5V17.9893", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 6.5L12 2L3 6.5V17.5L12 22L21 17.5V6.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Blockchain03Icon;
